import { LinkField, Field } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  DynamicPlaceholderParams,
  KeyValuePair,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

export type N07CorporateFooterProps = RenderingProps<
  N07CorporateFooterFields,
  N07CorporateFooterParams
>;

export type N07CorporateFooterFields = {
  SocialMediaLinks?: SocialMediaLink[];
  CopyrightText?: Field<string>;
  LegalAndPrivacyLink?: LinkField;
};
export interface SocialMediaLink {
  fields?: {
    Type?: KeyValuePair;
    Link?: LinkField;
  };
}
export type N07CorporateFooterParams = DynamicPlaceholderParams & TranslationOptionsParams;
